import httpClient from './httpClient';
import { ENDPOINT_API } from '../../enums/endpoint';

const getBranchStocks = (params) => httpClient.get(`${ENDPOINT_API.BRANCH_STOCKS}`, { params });
const getBranchStocksDetail = (id) => httpClient.get(`${ENDPOINT_API.BRANCH_STOCKS}/${id}`);
const getBranchStocksSkus = (params, id) => httpClient.get(`${ENDPOINT_API.BRANCH_STOCKS}/${id}/skus`, { params });

export {
	getBranchStocks,
	getBranchStocksDetail,
	getBranchStocksSkus,
};
